function CUtils()
{

}

/**
 * Load ajax remote url response into an htlm element
 *
 * @param strRemoteUrl
 * @param objData
 * @param strHtmlElementSelector
 * @param callback
 * @param objOptions
 *
 * @static
 */
CUtils.loadAjaxContentIntoHtmlElement = function(strRemoteUrl, objData, strHtmlElementSelector, callback, objOptions)
{
    var bAsync = true;
    var strAjaxMethod =  "get";
    var strDatatype = "html";

    if (typeof objOptions !== "undefined")
    {
        if ('async' in objOptions && objOptions.async === false)
        {
            throw new Error("Async is no longer supported");
        }

        if ('dataType' in objOptions)
        {
            strDatatype = objOptions.dataType;
        }
    }

    $.ajax({
            type: strAjaxMethod,
            url: strRemoteUrl,
            dataType : strDatatype,
            data : objData,
        })
        .done(function(data)
        {
            if(strDatatype ==="html")
            {
                $(strHtmlElementSelector).html(data);

            }
            else
            {
                $(strHtmlElementSelector).html(data.html);

                //// if appswitcher also set up for mobile
                //if(strHtmlElementSelector === "#appSwitcher")
                //{
                //    $("#appSwitcherMobile").html(data.html);
                //}
            }
            callback(null, true);
        })
        .fail(function()
        {
            callback('There was an error while loading remote url :' + strRemoteUrl, null);
        });
};

CUtils.enableMultipleModals = function()
{
    // Fix for handling multiple modal windows
    $('.modal').on('hidden.bs.modal', function( event ) {
        $(this).removeClass( 'fv-modal-stack' );
        if ($('body').data( 'fv_open_modals' ) > 0) {
            $('body').data( 'fv_open_modals', $('body').data( 'fv_open_modals' ) - 1 );
        }
    });

    $( '.modal' ).on( 'shown.bs.modal', function ( event ) {
        if ( typeof( $('body').data( 'fv_open_modals' ) ) == 'undefined' )
        {
            $('body').data( 'fv_open_modals', 0 );
        }

        if ( $(this).hasClass( 'fv-modal-stack' ) )
        {
            return;
        }
        $(this).addClass( 'fv-modal-stack' );
        $('body').data( 'fv_open_modals', $('body').data( 'fv_open_modals' ) + 1 );
        $(this).css('z-index', 1040 + (10 * $('body').data( 'fv_open_modals' )));
        $( '.modal-backdrop' ).not( '.fv-modal-stack' )
            .css( 'z-index', 1039 + (10 * $('body').data( 'fv_open_modals' )));
        $( '.modal-backdrop' ).not( 'fv-modal-stack' )
            .addClass( 'fv-modal-stack' );
    });
};

CUtils.Strings = {};

CUtils.Strings.capitalize = function( strWord )
{
    return strWord.charAt(0).toUpperCase() + strWord.toLowerCase().slice(1);
};

CUtils.Strings.replaceAll = function( strText, strFind, strReplace )
{
    return strText.replace(new RegExp(strFind, 'g'), strReplace);
};

CUtils.getBasenameFromPath = function( strString )
{
    if (typeof strString !== 'string' || !strString.length)
    {
        return false;
    }

    return strString.replace(/^.*[\\\/]/, '');
};

CUtils.getFilenameWithoutExtension = function( strFilename )
{
    var arrParts = strFilename.split('.');
    if (arrParts.length === 1) {
        return arrParts.pop();
    }

    arrParts.pop(); // remove extension
    return arrParts.join('.');
};

CUtils.getFilenameExtension = function( strFilename )
{
    // doesnt work for dot files
    var arrParts = strFilename.split('.');
    if (arrParts.length === 1)
    {
        return '';
    }
    return strFilename.split('.').pop();
};

CUtils.Bootstrap = {};

CUtils.Bootstrap.autoCenterModals = function()
{
    var reposition = function()
    {
        var modal = $(this);
        var dialog = modal.find('.modal-dialog');

        modal.css('display', 'block');
        dialog.css("padding-top", 0);
        dialog.css("margin-top", Math.max(0, ($(window).height() - dialog.height()) / 3));
    };

    // Reposition when a modal is shown
    $('.modal').on('show.bs.modal', reposition);

    // Reposition when the window is resized
    $(window).on('resize', function() {
        $('.modal:visible').each(reposition);
    });
};




CUtils.Bootstrap.enablePopovers = function()
{
    $('[data-toggle="popover"]').popover({
        container: 'body'
    });

};